import React, { useState } from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';
import Step1Upload from './Step1Upload';
import Step2Review from './Step2Review';
import Step3Details from './Step3Details';
import UploadSuccess from './UploadSuccess';

const UploadProcess = () => {
    const [image, setImage] = useState(null);
    const [ocrData, setOcrData] = useState({});
    const [tags, setTags] = useState([]);

    return (
        <Routes>
            <Route index element={<Navigate to="step1" replace />} />
            <Route path="step1" element={<Step1Upload setImage={setImage} />} />
            <Route path="step2" element={<Step2Review image={image} ocrData={ocrData} setOcrData={setOcrData} />} />
            <Route path="step3" element={<Step3Details ocrData={ocrData} tags={tags} setTags={setTags} />} />
            <Route path="success" element={<UploadSuccess />} />
        </Routes>
    );
};

export default UploadProcess;
